/* eslint-disable import/prefer-default-export */

const paymentMethods = (state) => {
    const userPaymentMethod = state?.loader?.user?.paymentMethods

    if (userPaymentMethod && userPaymentMethod.length > 0) {
        return userPaymentMethod
    }

    const paymentPaymentMethod = state?.payment?.paymentMethods

    if (paymentPaymentMethod) {
        return Object.keys(paymentPaymentMethod)
    }

    return []
}

const getSignupFormEmail = (state) => state?.account?.email

const accountHasPassword = (state) => state?.account?.hasPassword

const userIsAuthed = (state) => state?.auth?.isAuthed

const isVerifyingPayment = (state) => state?.plan?.isVerifyingPayment

export {
    paymentMethods,
    getSignupFormEmail,
    accountHasPassword,
    userIsAuthed,
    isVerifyingPayment,
}
